import { render, staticRenderFns } from "./RadioColumn.vue?vue&type=template&id=c849ec36&"
import script from "./RadioColumn.vue?vue&type=script&lang=js&"
export * from "./RadioColumn.vue?vue&type=script&lang=js&"
import style0 from "./RadioColumn.vue?vue&type=style&index=0&id=c849ec36&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports